import { LeadModel } from '../../api/Argentia/endpoints/leads/model/leads'
import { LeadFormSearchFilter } from '../../pages/leads/components/searchFilterCard/searchFilterCard'
import { LeadsSearchMode } from '../../pages/leads/leads.model'

export enum LeadsActionTypes {
  STORE_LEADS_SEARCH_MODE = 'SET_LEADS_SEARCH_MODE',
  STORE_LEADS_DATATABLE = 'STORE_LEADS_DATATABLE',
  STORE_LEADS_SEARCHFILTERS = 'STORE_LEADS_SEARCHFILTERS'
}

export interface StoreLeadsSearchModeAction {
  type: LeadsActionTypes
  payload: LeadsSearchMode | null
}

export interface StoreLeadsSearchFilterAction {
  type: LeadsActionTypes
  payload: LeadFormSearchFilter | null
}

export interface StoreLeadsDatatableAction {
  type: LeadsActionTypes
  payload: LeadModel[] | null
}

export const storeLeadSearchModeAction = (
  leadSearchMode: LeadsSearchMode
): StoreLeadsSearchModeAction => {
  return { type: LeadsActionTypes.STORE_LEADS_SEARCH_MODE, payload: leadSearchMode }
}

export const storeLeadsSearchFilters = (
  filters: LeadFormSearchFilter
): StoreLeadsSearchFilterAction => {
  return { type: LeadsActionTypes.STORE_LEADS_SEARCHFILTERS, payload: filters }
}

export const storeLeadsDatatableAction = (
  leadsDataTable: LeadModel[]
): StoreLeadsDatatableAction => {
  return { type: LeadsActionTypes.STORE_LEADS_DATATABLE, payload: leadsDataTable }
}
